import { PageContainer } from "../../../../components/common/page-container";
import { AppCard } from "../../../../components/common/card";
import { CreatePartnerForm } from "../components/create-partner-form";

export function CreatePartnerPage() {
  return (
    <PageContainer>
      <AppCard
        title="Create New Partner"
        color="bg-bgDefault"
        className="w-full max-sm:px-4"
        backButton={true}
      >
        <CreatePartnerForm />
      </AppCard>
    </PageContainer>
  );
}
